import API from 'app/utils/apiClient';

import { toParams } from 'app/utils/url';

const getMarketItems = (type, page = 1, perPage = 20) => {
  const params = toParams({ type, page, perPage });
  return API.get(`/store/market-items/?${params}`);
};

const getMarketItemOptions = itemId =>
  API.get(`/store/market-items/${itemId}/options/`);

const purchaseMarketItem = (itemId, optionId) =>
  API.post(`/store/market-items/${itemId}/options/${optionId}/purchase/`);

const getMyMarketInventories = () => API.get('/users/me/market-item-inventories/');

const patchMarketInventory = (inventoryId, status) =>
  API.patch(`/users/me/market-item-inventories/${inventoryId}/`, { status });


const getMarketCurations = () => API.get('/store/market-curations/');

export default {
  getMarketItems,
  getMarketItemOptions,
  purchaseMarketItem,
  getMyMarketInventories,
  patchMarketInventory,
  getMarketCurations,
};



// WEBPACK FOOTER //
// ./src/app/apis/market.js